import moment from 'moment';
import { CATEGORIES } from "./constants";

export  const getFormatedDate = (date) => moment.unix(date).format("DD.MM.YYYY HH:mm");

export const getPhoto = (customer) => customer.images[0];

export const getDocumentTypeText = (type) => type === 'PASSPORT' ? 'Անձնագիր' : 'Նույնականացման քարտ';

export const getCategoryText = (category) => CATEGORIES[category];

export const formatAmount = (number, separator = ',') => {
  if (typeof number === 'undefined' || number === null) {
    return 0;
  }

  const str = number.toString().split('.');
  str[0] = (str[0] || '').replace(/^0+/, '') || '0';

  if (str[0].length >= 4) {
    str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, `$1${separator}`);
  }

  return str[0];
};

export const getDayDiff = (date) => {
  const currentDate = moment().unix();
  const start = moment.unix(currentDate);
  const end = moment.unix(date);

  return  Math.ceil(moment.duration(start.diff(end)).asDays());
}

export const getUrlPath = (url) => {
  var urlObj
  if(url.startsWith('http')) {
    urlObj = new URL(url)
  } else {
    urlObj = new URL(`http://${url}`)
  }
  return urlObj.pathname;
}
